import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import orderService from '../services/orderService';

const OrderListPage = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [syncLoading, setSyncLoading] = useState(false);

  // 🔥 YENİ: Filtre ve pagination state'leri
  const [filters, setFilters] = useState({
    status: '',
    customerEmail: '',
    startDate: '',
    endDate: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [statuses] = useState(['paid', 'pending', 'cancelled', 'refunded', 'fulfilled']);

  // 🔥 YENİ: Pagination state
  const [pagination, setPagination] = useState({
    currentPage: 0,
    totalPages: 0,
    totalElements: 0,
    pageSize: 10
  });

  useEffect(() => {
    console.log('📦 OrderListPage: Component mount oldu');
    loadOrders();
  }, []);

  // 🔥 YENİ: Pagination ile orders yükle
  const loadOrders = async (page = 0) => {
    try {
      setLoading(true);
      setError(null);

      // 🔥 FİLTRE DEĞERLERİNİ KONTROL ET
      console.log('🔍 Filters debug:', {
        status: filters.status,
        customerEmail: filters.customerEmail,
        startDate: filters.startDate,
        endDate: filters.endDate
      });

      const params = new URLSearchParams();

      // 🔥 FİLTRE DEĞERLERİNİ DOĞRU ŞEKİLDE EKLE
      if (filters.status && typeof filters.status === 'string') {
        params.append('status', filters.status);
      }
      if (filters.customerEmail && typeof filters.customerEmail === 'string') {
        params.append('customerEmail', filters.customerEmail);
      }
      if (filters.startDate && typeof filters.startDate === 'string') {
        params.append('startDate', filters.startDate);
      }
      if (filters.endDate && typeof filters.endDate === 'string') {
        params.append('endDate', filters.endDate);
      }
      params.append('page', page);
      params.append('size', 10);

      const url = `https://medi-panel.cloud/api/orders/filtered?${params.toString()}`;
      console.log('🔄 Final URL:', url);

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: Filtreli order listesi getirilemedi`);
      }

      const data = await response.json();
      console.log('✅ Orders loaded:', data.content.length, 'items');

      setOrders(data.content);
      setPagination({
        currentPage: data.number,
        totalPages: data.totalPages,
        totalElements: data.totalElements,
        pageSize: data.size
      });

    } catch (err) {
      console.error('❌ OrderListPage: Orders yüklenirken hata:', err);
      setError('Siparişler yüklenirken bir hata oluştu: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSyncOrders = async () => {
    try {
      setSyncLoading(true);
      console.log('🔄 OrderListPage: Sync başlatılıyor...');

      await orderService.syncOrders();
      console.log('✅ OrderListPage: Sync tamamlandı, orders yeniden yükleniyor...');

      await loadOrders(0); // Sync sonrası ilk sayfaya dön
      alert('✅ Siparişler başarıyla senkronize edildi!');
    } catch (err) {
      console.error('❌ OrderListPage: Sync hatası:', err);
      alert('❌ Senkronizasyon sırasında hata: ' + err.message);
    } finally {
      setSyncLoading(false);
    }
  };

  // 🔥 YENİ: Filtre işlemleri
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const applyFilters = () => {
    console.log('🎯 Filtreler uygulanıyor:', filters);
    loadOrders(0); // Filtre değişince ilk sayfaya dön
    setShowFilters(false);
  };

  const clearFilters = () => {
    console.log('🧹 Filtreler temizleniyor');
    setFilters({
      status: '',
      customerEmail: '',
      startDate: '',
      endDate: ''
    });
    loadOrders(0); // Filtresiz yükle, ilk sayfaya dön
    setShowFilters(false);
  };

  // 🔥 YENİ: Sayfa değiştirme
  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < pagination.totalPages) {
      loadOrders(newPage);
    }
  };

  const getActiveFilterCount = () => {
    return Object.values(filters).filter(value => value !== '').length;
  };

  const getStatusColor = (status) => {
    const statusColors = {
      'paid': '#4caf50',
      'pending': '#ff9800',
      'cancelled': '#f44336',
      'refunded': '#9e9e9e',
      'fulfilled': '#2196f3'
    };
    return statusColors[status] || '#666';
  };

  const getStatusText = (status) => {
    const statusTexts = {
      'paid': 'Ödendi',
      'pending': 'Beklemede',
      'cancelled': 'İptal Edildi',
      'refunded': 'İade Edildi',
      'fulfilled': 'Tamamlandı'
    };
    return statusTexts[status] || status;
  };

  const calculateTotalItems = (items) => {
    if (!items || items.length === 0) return 0;
    return items.reduce((total, item) => total + (item.quantity || 0), 0);
  };

  // 🔥 YENİ: Pagination butonları component'i
  const PaginationControls = () => {
    if (pagination.totalPages <= 1) return null;

    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        margin: '2rem 0',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => handlePageChange(pagination.currentPage - 1)}
          disabled={pagination.currentPage === 0}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: pagination.currentPage === 0 ? '#ccc' : '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: pagination.currentPage === 0 ? 'not-allowed' : 'pointer'
          }}
        >
          ◀ Önceki
        </button>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontSize: '0.9rem',
          color: '#666'
        }}>
          <span>Sayfa</span>
          <strong>{pagination.currentPage + 1} / {pagination.totalPages}</strong>
          <span>({pagination.totalElements} sipariş)</span>
        </div>

        <button
          onClick={() => handlePageChange(pagination.currentPage + 1)}
          disabled={pagination.currentPage >= pagination.totalPages - 1}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: pagination.currentPage >= pagination.totalPages - 1 ? '#ccc' : '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: pagination.currentPage >= pagination.totalPages - 1 ? 'not-allowed' : 'pointer'
          }}
        >
          Sonraki ▶
        </button>
      </div>
    );
  };

  // Loading state
  if (loading) {
    return (
      <div style={{
        padding: '1rem',
        paddingBottom: '80px',
        textAlign: 'center'
      }}>
        <h1>📦 Siparişler</h1>
        <div style={{
          padding: '2rem',
          fontSize: '1.2rem',
          color: '#666'
        }}>
          ⏳ Siparişler yükleniyor...
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div style={{
        padding: '1rem',
        paddingBottom: '80px',
        textAlign: 'center'
      }}>
        <h1>📦 Siparişler</h1>
        <div style={{
          padding: '2rem',
          color: '#f44336',
          backgroundColor: '#ffebee',
          borderRadius: '8px',
          margin: '1rem 0'
        }}>
          ❌ {error}
        </div>
        <button
          onClick={() => loadOrders(pagination.currentPage)}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          🔄 Tekrar Dene
        </button>
      </div>
    );
  }

  return (
    <div style={{
      padding: '1rem',
      paddingBottom: '80px',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      {/* HEADER */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        flexWrap: 'wrap',
        gap: '1rem'
      }}>
        <div>
          <h1 style={{
            margin: '0 0 0.25rem 0',
            color: '#1976d2',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            📦 Siparişler
            <span style={{
              fontSize: '0.8rem',
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              padding: '0.2rem 0.5rem',
              borderRadius: '12px'
            }}>
              {pagination.totalElements} adet
            </span>
          </h1>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
            Sayfa {pagination.currentPage + 1} / {pagination.totalPages}
          </p>
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          {/* Filtre Butonu */}
          <button
            onClick={() => setShowFilters(!showFilters)}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: getActiveFilterCount() > 0 ? '#ff9800' : '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontSize: '0.9rem'
            }}
          >
            🎯 Filtrele
            {getActiveFilterCount() > 0 && (
              <span style={{
                backgroundColor: 'white',
                color: '#ff9800',
                borderRadius: '50%',
                width: '18px',
                height: '18px',
                fontSize: '0.7rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {getActiveFilterCount()}
              </span>
            )}
          </button>

          <button
            onClick={handleSyncOrders}
            disabled={syncLoading}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: syncLoading ? '#ccc' : '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: syncLoading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontSize: '0.9rem'
            }}
          >
            {syncLoading ? '⏳' : '🔄'}
            {syncLoading ? 'Senkronize...' : 'Shopify\'dan Getir'}
          </button>
          {/* 🔥 YENİ: PURCHASE ORDER'LAR Butonu */}
          <button
            onClick={() => navigate('/purchase-orders')}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#e77f08',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontSize: '0.9rem',
              fontWeight: 'bold'
            }}
          >
            📄 Purchase Orders
          </button>
        </div>
      </div>

      {/* FİLTRE PANELİ */}
      {showFilters && (
        <div style={{
          backgroundColor: 'white',
          padding: '1rem',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          marginBottom: '1rem',
          border: '1px solid #e0e0e0'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '1rem',
            alignItems: 'end'
          }}>
            {/* Status Filtresi */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.8rem', fontWeight: '500', color: '#555' }}>
                📊 Status
              </label>
              <select
                value={filters.status}
                onChange={(e) => handleFilterChange('status', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '0.9rem'
                }}
              >
                <option value="">Tüm Statusler</option>
                {statuses.map(status => (
                  <option key={status} value={status}>
                    {getStatusText(status)}
                  </option>
                ))}
              </select>
            </div>

            {/* Email Filtresi */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.8rem', fontWeight: '500', color: '#555' }}>
                📧 Müşteri Email
              </label>
              <input
                type="text"
                value={filters.customerEmail}
                onChange={(e) => handleFilterChange('customerEmail', e.target.value)}
                placeholder="Email ile ara..."
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '0.9rem'
                }}
              />
            </div>

            {/* Tarih Filtreleri */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.8rem', fontWeight: '500', color: '#555' }}>
                📅 Başlangıç Tarihi
              </label>
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) => handleFilterChange('startDate', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '0.9rem'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.8rem', fontWeight: '500', color: '#555' }}>
                📅 Bitiş Tarihi
              </label>
              <input
                type="date"
                value={filters.endDate}
                onChange={(e) => handleFilterChange('endDate', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '0.9rem'
                }}
              />
            </div>
          </div>

          {/* Filtre Butonları */}
          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem', justifyContent: 'flex-end' }}>
            <button
              onClick={clearFilters}
              style={{
                padding: '0.4rem 0.8rem',
                backgroundColor: '#f5f5f5',
                color: '#666',
                border: '1px solid #ddd',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.8rem'
              }}
            >
              🧹 Temizle
            </button>
            <button
              onClick={applyFilters}
              style={{
                padding: '0.4rem 0.8rem',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.8rem'
              }}
            >
              ✅ Uygula
            </button>
          </div>
        </div>
      )}

      {/* AKTİF FİLTRELER GÖSTERİMİ */}
      {getActiveFilterCount() > 0 && (
        <div style={{
          backgroundColor: '#e3f2fd',
          padding: '0.5rem 1rem',
          borderRadius: '4px',
          marginBottom: '1rem',
          fontSize: '0.8rem',
          color: '#1976d2'
        }}>
          <strong>🎯 Aktif Filtreler:</strong>
          {filters.status && ` Status: ${getStatusText(filters.status)}`}
          {filters.customerEmail && ` Email: ${filters.customerEmail}`}
          {filters.startDate && ` Başlangıç: ${filters.startDate}`}
          {filters.endDate && ` Bitiş: ${filters.endDate}`}
        </div>
      )}

      {/* PAGINATION CONTROLS - ÜST */}
      <PaginationControls />

      {/* ORDER LIST */}
      <div>
        {orders.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem',
            color: '#666',
            backgroundColor: 'white',
            borderRadius: '8px',
            border: '2px dashed #ddd'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📭</div>
            <h3>Henüz sipariş bulunmuyor</h3>
            <p>
              {getActiveFilterCount() > 0
                ? 'Seçtiğiniz filtrelerle eşleşen sipariş bulunamadı.'
                : 'Siparişleri Shopify\'dan getirmek için yukarıdaki butonu kullanın.'
              }
            </p>
          </div>
        ) : (
          orders.map(order => (
            <Link
              key={order.id}
              to={`/orders/${order.id}`}
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'block'
              }}
            >
              <div
                style={{
                  backgroundColor: 'white',
                  border: '1px solid #e0e0e0',
                  padding: '1rem',
                  marginBottom: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                }}
              >
                {/* ORDER HEADER */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: '0.5rem',
                  flexWrap: 'wrap',
                  gap: '0.5rem'
                }}>
                  <div>
                    <h3 style={{ margin: '0 0 0.25rem 0', color: '#333' }}>
                      #{order.orderNumber}
                    </h3>
                    <p style={{
                      margin: 0,
                      fontSize: '0.9rem',
                      color: '#666',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <span>📧 {order.customerEmail}</span>
                    </p>
                  </div>

                  <div style={{ textAlign: 'right' }}>
                    <span
                      style={{
                        backgroundColor: getStatusColor(order.status),
                        color: 'white',
                        padding: '0.3rem 0.8rem',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        fontWeight: 'bold'
                      }}
                    >
                      {getStatusText(order.status)}
                    </span>
                    <p style={{
                      margin: '0.25rem 0 0 0',
                      fontSize: '0.8rem',
                      color: '#666'
                    }}>
                      📅 {new Date(order.orderDate).toLocaleDateString('tr-TR')}
                    </p>
                  </div>
                </div>

                {/* ORDER ITEMS */}
                <div style={{
                  marginTop: '0.5rem',
                  paddingTop: '0.5rem',
                  borderTop: '1px solid #f0f0f0'
                }}>
                  <p style={{
                    margin: '0 0 0.5rem 0',
                    fontSize: '0.9rem',
                    color: '#666',
                    fontWeight: 'bold'
                  }}>
                    📋 Ürünler ({calculateTotalItems(order.items)})
                  </p>

                  {order.items?.slice(0, 2).map((item, index) => (
                    <div
                      key={item.id || index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0.5rem',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '4px',
                        marginBottom: '0.25rem'
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                          {item.productTitle}
                        </div>
                        {/* 🔥 YENİ: QUANTITY BİLGİSİ */}
                        <div style={{ fontSize: '0.8rem', color: '#666', fontWeight: 'bold' }}>
                          🔢 Adet: {item.quantity}
                        </div>
                        {item.variantTitle && (
                          <div style={{ fontSize: '0.8rem', color: '#666' }}>
                            {item.variantTitle}
                          </div>
                        )}
                      </div>

                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                          {item.quantity} × ${item.unitPrice}
                        </div>
                        <div style={{ fontSize: '0.8rem', color: '#4caf50', fontWeight: 'bold' }}>
                          ${item.totalPrice}
                        </div>
                      </div>
                    </div>
                  ))}

                  {order.items && order.items.length > 2 && (
                    <div style={{
                      textAlign: 'center',
                      padding: '0.25rem',
                      color: '#666',
                      fontSize: '0.8rem'
                    }}>
                      + {order.items.length - 2} daha...
                    </div>
                  )}
                </div>

                {/* DETAY LİNKİ */}
                <div style={{
                  marginTop: '0.5rem',
                  paddingTop: '0.5rem',
                  borderTop: '1px solid #f0f0f0',
                  textAlign: 'center'
                }}>
                  <span style={{
                    color: '#1976d2',
                    fontSize: '0.8rem',
                    fontWeight: 'bold'
                  }}>
                    👆 Detayları görüntülemek için tıklayın
                  </span>
                </div>
              </div>
            </Link>
          ))
        )}
      </div>

      {/* PAGINATION CONTROLS - ALT */}
      <PaginationControls />

      {/* REFRESH BUTTON */}
      {orders.length > 0 && (
        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <button
            onClick={() => loadOrders(pagination.currentPage)}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            🔄 Listeyi Yenile
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderListPage;